// 直播相关配置
export const LIVE_CONFIG = {
  // TCPlayer 授权配置
  PLAYER_LICENSE_URL: 'https://1327679345.trtcube-license.cn/license/v2/1327679345_1/v_cube.license',
  // 真实值放 .env.production.local（不进仓库）；该 key 会打进前端包，真正的防护是控制台里的域名白名单
  PLAYER_LICENSE_KEY: process.env.VUE_APP_TCPLAYER_LICENSE_KEY || '',
  
  // 播放器默认配置
  PLAYER_CONFIG: {
    autoplay: false,
    controls: true,
    muted: true,
    preload: 'metadata',
    playsinline: true,
    webkitPlaysinline: true,
    live: true,
    fluid: true,
    responsive: true
  },
  
  // 播放协议优先级（PC端）
  PLAY_PROTOCOL_PRIORITY: [
    'webrtc', // WebRTC：强烈推荐，秒开效果最好，支持超高并发
    'flv',    // HTTP-FLV：推荐，秒开效果好，支持超高并发
    'hls'     // HLS：兼容性好，但延迟较高
  ]
}

// 获取播放器配置
export function getPlayerConfig(playUrl, licenseUrl = null) {
  return {
    ...LIVE_CONFIG.PLAYER_CONFIG,
    sources: [{ src: playUrl }],
    licenseUrl: licenseUrl || process.env.VUE_APP_TCPLAYER_LICENSE_URL || LIVE_CONFIG.PLAYER_LICENSE_URL
  }
}

/**
 * 把腾讯云的 http 播放地址换成同源反代路径。
 *
 * 管理端是 https 页面，而后端 LiveUtil 生成的 flv/hls 是 http://playlive.scqyrx.cn/...，
 * 直接用会被浏览器当混合内容拦掉；换成 https 又过不了 TLS —— 腾讯云那个域名上
 * 没配我们的证书（它返回 *.liveplay.myqcloud.com）。所以走管理端 nginx 的 /liveproxy/ 反代。
 *
 * webrtc:// 不经过它：那是播放器自己的信令通道，不走 http 栈，也没有混合内容问题。
 *
 * 等哪天腾讯云控制台给 playlive.scqyrx.cn 传了 *.scqyrx.cn 证书，
 * 这个函数可以直接 return url，nginx 那段反代也能去掉。
 */
export function toProxyUrl(url) {
  if (!url || typeof url !== 'string') return url
  const m = url.match(/^https?:\/\/[^/]*playlive\.scqyrx\.cn\/(.*)$/i)
  return m ? '/liveproxy/' + m[1] : url
}

// 获取最佳播放地址
export function getBestPlayUrl(streamUrls) {
  console.log('getBestPlayUrl 输入参数:', streamUrls)
  
  const urls = [
    streamUrls.playWebRtc,    // WebRTC：强烈推荐，秒开效果最好，支持超高并发
    streamUrls.playFlvUri,    // HTTP-FLV：推荐，秒开效果好，支持超高并发
    streamUrls.playHlsUri     // HLS：兼容性好，但延迟较高
  ]
  
  console.log('所有播放地址:', urls)
  
  // 过滤掉空值
  const validUrls = urls.filter(url => url && url.trim())
  
  console.log('有效播放地址:', validUrls)
  
  if (validUrls.length === 0) {
    console.warn('没有可用的播放地址')
    return null
  }
  
  // PC端播放优先级：WebRTC > HTTP-FLV > HLS
  const webRtcUrl = validUrls.find(url => url.includes('webrtc://'))
  if (webRtcUrl) {
    console.log('选择 WebRTC 播放地址:', webRtcUrl)
    return webRtcUrl
  }
  
  const flvUrl = validUrls.find(url => url.includes('.flv'))
  if (flvUrl) {
    console.log('选择 HTTP-FLV 播放地址:', flvUrl)
    return flvUrl
  }
  
  const hlsUrl = validUrls.find(url => url.includes('.m3u8'))
  if (hlsUrl) {
    console.log('选择 HLS 播放地址:', hlsUrl)
    return hlsUrl
  }
  
  console.log('选择第一个可用地址:', validUrls[0])
  return validUrls[0]
}
